module.exports = __webpack_public_path__ + "static/after1-ff596ec30a99492df4b72ed94a60affb.jpg";